import React from 'react';
import {inject, observer} from 'mobx-react';

@inject('listStore')
@observer
class ListDoing extends React.Component {
  render() {
    return (
      <div>
        listDoing
      </div>
    )
  }
}

export default ListDoing



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/components/ListDoing.js